"use strict";
async function startApp() {
    const { bootstrap } = await import("./bootstrap");
    bootstrap();
}
void startApp();
